import React, { useEffect } from 'react';
import { useFormikContext } from 'formik';
import Grid from '@mui/material/Grid';

import DynamicFieldArray from '../MaterialComponents/DynamicFieldArray';

const VideoPageSetup = (props) => {
  const { values } = useFormikContext();
  const { stimOnly } = props; 


  useEffect(() => {
    values.external_step_name = `${values.name}-${values.external_step_url}`;
  }, [values.external_step_url]);

  return (
    <>
     <Grid item xs={12}>
      <DynamicFieldArray {...props} stimOnly={stimOnly} />
            </Grid>
    </>
  );
};

export default VideoPageSetup;
